import script from "./AdditionalAttributesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalAttributesModal.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalAttributesModal.vue?vue&type=style&index=0&id=ddcd2a5c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddcd2a5c"]])

export default __exports__